import {
  LAYOUTS,
  MENU_SECTIONS,
  MODULE_SETTINGS,
  USER_ROLES,
} from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";

import { ACTIONPLAN_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    name: ACTIONPLAN_ROUTE_NAMES.STUDENT_INDEX,
    path: "/my-actionplans",
    component: () => import("views/EmptyView.vue"),
    redirect: { name: ACTIONPLAN_ROUTE_NAMES.STUDENT_OPEN },
    meta: {
      title: "Mijn actieplan",
      roleRequired: [USER_ROLES.STUDENT],
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      isMenuItem: true,
      inDropdown: true,
      hasSubmenu: true,
      menuSection: MENU_SECTIONS.MAIN,
      menuOrder: 13,
      icon: "/images/menu/actionplan.svg",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      studentView: true,
    },
    children: [
      {
        name: ACTIONPLAN_ROUTE_NAMES.STUDENT_OPEN,
        path: "open",
        component: () => import("actionplan/pages/StudentActionplansPage.vue"),
        meta: {
          title: "Actieplannen",
          tabLabel: "Openstaand",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
          inDropdown: true,
        },
      },
      {
        name: ACTIONPLAN_ROUTE_NAMES.STUDENT_COMPLETED,
        path: "completed",
        component: () => import("actionplan/pages/StudentActionplansPage.vue"),
        meta: {
          title: "Actieplannen",
          tabLabel: "Afgerond",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
          inDropdown: true,
        },
      },
      // Nested so the sidebar keeps "Mijn actieplan" active while the student
      // is on the form; the tab bar skips them because they are not inDropdown.
      {
        name: ACTIONPLAN_ROUTE_NAMES.STUDENT_CREATE,
        path: "create",
        component: () =>
          import("actionplan/pages/StudentActionplanCreatePage.vue"),
        meta: {
          title: "Actieplan aanmaken",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
          layout: LAYOUTS.MAIN_NO_WRAPPER,
          hideTitle: true,
          hideSubmenu: true,
        },
      },
      {
        name: ACTIONPLAN_ROUTE_NAMES.STUDENT_EDIT,
        path: ":id/edit",
        component: () =>
          import("actionplan/pages/StudentActionplanEditPage.vue"),
        meta: {
          title: "Actieplan aanpassen",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
          layout: LAYOUTS.MAIN_NO_WRAPPER,
          hideTitle: true,
          hideSubmenu: true,
        },
      },
    ],
  },
];

export default routes;
